// extracted by mini-css-extract-plugin
export default {"home_page":"home_home_page__5qpog"};